import { memo, useEffect, useRef, useState } from 'react';
import { Col, Row, Skeleton, Collapse } from 'antd';
import { chunk } from 'lodash';
import { useMediaQuery } from 'react-responsive';
// import { useSelector } from 'react-redux';
import Caption from '../../Caption/Caption';
import { useGetFooterLinkQuery, FooterLinks } from './FooterLinksSlice';
import ListItem from '../../List-Item/ListItem';

import './styles.scss';
// import { commonState } from '../../../../app/base/commonSlice';

function LargeFooterBottom() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // const isExtraLargeScreen = useMediaQuery({ minWidth: 2560 });
  // const { footerApiCall } = useSelector(commonState);

  const [shouldFetch, setShouldFetch] = useState(false);
  const footerRef = useRef(null); // Reference to the footer element

  useEffect(() => {
    // Function to check if the footer is already visible
    const checkIfFooterIsVisible = () => {
      if (!footerRef.current) return false;
      // @ts-ignore
      const rect = footerRef.current.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    };

    setTimeout(() => {
      if (checkIfFooterIsVisible()) {
        setShouldFetch(true);
      }
    }, 100);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldFetch(true);
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(footerRef.current);
      }
    };
  }, []);

  const { data: footerLinkData, isLoading: footerLinkDataLoading } =
    useGetFooterLinkQuery(undefined, {
      skip: !shouldFetch,
    });

  const footerLinks =
    footerLinkData?.results.filter((item) => item?.is_active) || [];

  const maxNumCols = 3; // Define the maximum number of columns (maximum of 3 in this case)

  const dividedData = chunk(
    footerLinks,
    Math.ceil(footerLinks.length / maxNumCols)
  );

  const importantLink = () => {
    return (
      <>
        {dividedData.map((group, columnIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <Col span={8} key={columnIndex} className="pr-6">
            {group.map((item: FooterLinks) => (
              <ListItem
                key={item?.id}
                caption_en={item?.title_en}
                caption_bn={item?.title_bn}
                link={item?.url}
                target
                captionSize="lg"
                captionColor="gray-400"
              />
            ))}
          </Col>
        ))}
      </>
    );
  };

  return (
    <div ref={footerRef}>
      {isMobile && (
        <div className="py-10 px-4 md:px-0">
          <Row className="md:pl-[150px] pl-[10px]  md:pr-[50px] pr-[10px] footer-collapse">
            <Collapse
              expandIconPosition="end"
              className="w-full"
              bordered={false}
              rootClassName="bg-[#071014]"
            >
              <Collapse.Panel
                header={
                  <Caption
                    text_en="What we do"
                    text_bn="আমরা যা করি"
                    fontWeight="extrabold"
                    fontSize="3xl"
                    color="white"
                  />
                }
                key="1"
              >
                <Row>{importantLink()}</Row>
              </Collapse.Panel>
            </Collapse>
          </Row>
        </div>
      )}
      {!isMobile && (
        <div className="py-12 px-4 md:px-0">
          <Row className="md:pl-[120px] pl-[10px] md:pr-[120px] pr-[10px] mb-6">
            <Caption
              text_en="What we do"
              text_bn="আমরা যা করি"
              fontWeight="extrabold"
              fontSize="3xl"
              color="white"
            />
          </Row>

          <Row className="md:pl-[120px] pl-[10px]  md:pr-[120px] pr-[10px]">
            {footerLinkDataLoading && <Skeleton />}
            {importantLink()}
          </Row>
        </div>
      )}
    </div>
  );
}

export default memo(LargeFooterBottom);
